import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
/*
| UI
*/

import {Card, Col, Row, Container, Image} from "react-bootstrap";

/*
| PAGES
*/

import Section      from './Section';
import Background from './Background';
import FooterAnimation from './FooterAnimation';

/*
| ICONS
*/
import { GoChevronUp } from "react-icons/go";

export default class Footer extends Component {

    static defaultProps = {
        type : 'svg'
    }

    constructor(props){

        super(props);
        this.state = {
            type : this.props.type

        }

    }


    componentDidMount(){

    }

    getImage = () => {


    }

    render(){

        const scrollToTop = () => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          };

          const FooterTitle = ({ children }) => (
            <h5 className="text-uppercase  opacity-85 mb-3">{children}</h5>
          );
          
          const FooterList = ({ list }) => (
            <ul className="list-unstyled">
              {list.map(({ title, to }, index) => (
                <li className="mb-1" key={index}>
                  <a className="text-primary" href={to}>
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          ); 

          
const menuList1 = [
    { title: 'Accounting software Login', to: 'https://dashboard.varexe.com/' },
    { title: 'Accounting software register', to: 'https://dashboard.varexe.com/auth/register/' },
    { title: 'Website Design & Development', to: 'https://varexe.com/services/website-design-development' },
    { title: 'Web Hosting & Security', to: 'https://varexe.com/services/web-hosting-security' },
    { title: 'API Solutions', to: 'https://varexe.com/services/api-solutions' },
  ];
        return(
            <Fragment>

                  <Section  className="pt-8 pb-4  text-start">
                        <Row className=''>
                        <Col className='' lg={8}>
                        <FooterAnimation />
                            {/* <FooterTitle>Appatch Mission</FooterTitle> */}
                            <p className="text-600 mt-4">
                            ✨ Appatch crafted by <a href="http://fouadassadi.com/" target='_blank'>Fouad</a>, a Developer by Habit: I make it a habit to provide tools that resonate with the daily challenges faced by developers. Your success fuels my passion for creating solutions that matter.
                            </p>
                        </Col>
                        <Col className="mt-3">
                            <FooterTitle>Usefull Links</FooterTitle>
                            <FooterList list={menuList1}></FooterList>
                        
                        </Col>
                        </Row>
                    </Section>

                    <section className=" py-0 text-center fs--1 light">
                        <hr className="my-0 border-600 opacity-25" />
                        <div className="container py-3">
                        <Row className="justify-content-between">
                            <Col xs={12} sm="auto">
                            <p className="mb-0 text-600">
                                Appacth {' '}
                                <span className="d-none d-sm-inline-block">| </span>
                                <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
                                <a
                                className="text-primary opacity-85"
                                href="https://varexe.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                Varexe
                                </a>
                            </p>
                            </Col>
                            <Col xs={12} sm="auto">
                            {/* <p className="mb-0 text-600">v{version}</p> */}
                            </Col>
                        </Row>
                        </div>

                    </section>


                
            </Fragment>
        )
    }

}